<template id='product'>
  <div class="product" :class="{ zh: $t('m.lang') == 'zh' }">
    <main class="main">
      <header class="product-header">
        <p
          class="oculus"
          :style="{
            width: fullWidth <= 834 ? fullWidth * 0.45 + 'px' : 375 + 'px',
            height: fullWidth <= 834 ? fullWidth * 0.3 + 'px' : 247 + 'px',
            'margin-left':
              fullWidth <= 834
                ? -187.5 - (fullWidth - 835) * 0.22 + 'px'
                : -187.5 + 'px',
            bottom: fullWidth <= 834 ? -fullWidth * 0.15 + 'px' : -123.5 + 'px',
          }"
        >
          <img class="headset" data-2x="" :src="iconNum" />
        </p>
        <section class="header-content-wrapper">
          <section
            class="header-bg"
            :style="{
              width:
                fullWidth <= 768
                  ? fullWidth <= 540
                    ? 1020 + 'px'
                    : -1111.6 + 3.95 * fullWidth + 'px'
                  : fullWidth >= 1920
                  ? fullWidth + 'px'
                  : 1920 + 'px',
              height:
                fullWidth <= 768
                  ? fullWidth <= 640
                    ? 500 + 'px'
                    : -397.2 + 1.4 * fullWidth + 'px'
                  : fullWidth >= 1920
                  ? 678 - 0.353 * (1920 - fullWidth) + 'px'
                  : 678 + 'px',
              'margin-left':
                fullWidth <= 768
                  ? fullWidth <= 540
                    ? -510 + 'px'
                    : 555.8 - 1.97 * fullWidth + 'px'
                  : fullWidth >= 1920
                  ? -960 + 0.5 * (1920 - fullWidth) + 'px'
                  : -960 + 'px',
            }"
          >
            <img
              src="../assets/images/header.jpg "
              data-2x=""
              alt="skybox vr player"
            />
          </section>
          <article class="header-content">
            <p class="description">{{ $t("m.product.title") }}</p>
            <h2 class="title">
              <span
                class="inline-block"
                v-html="$t('m.product.skyboxOne')"
              ></span>
              <span class="inline-block">{{ $t("m.product.skyboxTwo") }}</span>
            </h2>
            <p>
              <router-link to="/get-zh" class="btn-header">
                <span class="icon-round-arrow-down"
                  ><svg
                    id="图层_1"
                    data-name="图层 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16.14 13.44"
                  >
                    <title>buy now</title>
                    <path
                      class="path-fill"
                      d="M14.75,8.75H6.36L3.49.38A.56.56,0,0,0,3,0H.56A.67.67,0,0,0,0,.67a.64.64,0,0,0,.56.65h2L5.43,9.67a.56.56,0,0,0,.53.38h8.78a.72.72,0,0,0,.67-.63A.76.76,0,0,0,14.75,8.75Zm.89-7.13-9.87-.3a.35.35,0,0,0-.37.51L7,7a.76.76,0,0,0,.76.41H15a.65.65,0,0,0,.63-.56l.52-4.62A.51.51,0,0,0,15.64,1.62Zm-2.23,9.12a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,13.41,10.74Zm-5.34,0a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,8.07,10.74Z"
                    ></path></svg></span
                >{{ $t("m.product.getapp") }}
              </router-link>
            </p>
          </article>
        </section>
      </header>

      <section class="product-wrapper">
        <section class="air-screen">
          <article class="content-wrapper">
            <h3 class="title">
              <span class="inline-block" v-html="$t('m.product.magic')"></span>
              <span class="inline-block">{{ $t("m.product.magicZero") }}</span>
            </h3>
            <p class="description">
              <span class="inline-block">
                {{ $t("m.product.magicOne") }}
              </span>
              <span class="inline-block">
                {{ $t("m.product.magicTwo") }}
              </span>
              <span class="inline-block"
                >{{ $t("m.product.magicThree") }}
              </span>
              <span class="inline-block"> {{ $t("m.product.magicFour") }}</span>
            </p>
            <p class="image">
              <img
                src="../assets/images/airscreen.png"
                data-2x=""
                alt="Stream Like Magic"
              />
            </p>
          </article>
        </section>

        <section class="platforms">
          <article class="content-wrapper">
            <h3 class="title">
              <span class="inline-block" v-html="$t('m.product.support')">
              </span>
              <span class="inline-block" v-html="$t('m.product.supportZero')">
              </span>
            </h3>
            <p class="description">
              <span class="inline-block">
                {{ $t("m.product.supportOne") }}
                {{ $t("m.product.supportThree") }}
              </span>
            </p>
            <ul class="platform-list">
              <li class="inline-block">
                <ul>
                  <li class="platform-item">
                    <img
                      src="../assets/images/platform-oculus-quest.png"
                      data-2x=""
                      alt="Oculus Quest"
                    />
                    <span class="platform-title">Oculus Quest</span>
                  </li>
                  <li class="platform-item">
                    <img
                      src="../assets/images/platform-valve-index.png"
                      data-2x=""
                      alt="Oculus Rift"
                    />
                    <span class="platform-title">Oculus Rift</span>
                  </li>
                </ul>
              </li>
              <li class="inline-block">
                <ul>
                  <li class="platform-item">
                    <img
                      src="../assets/images/platform-hp-reverb.png"
                      data-2x=""
                      alt="HP Reverb"
                    />
                    <span class="platform-title">HP Reverb</span>
                  </li>
                  <li class="platform-item">
                    <img
                      src="../assets/images/platform-oculus-rift.png"
                      data-2x=""
                      alt="Valve Index"
                    />
                    <span class="platform-title">Valve Index</span>
                  </li>
                </ul>
              </li>
            </ul>
          </article>
        </section>

        <section class="movie-theatre">
          <article
            class="content-wrapper"
            :style="{
              height:
                fullWidth * 0.45 <= 865
                  ? fullWidth * 0.45 <= 670
                    ? 670 + 'px'
                    : fullWidth * 0.45 + 'px'
                  : 865 + 'px',
            }"
          >
            <h3 class="title">{{ $t("m.product.envir") }}</h3>
            <p class="description">
              {{ $t("m.product.envirOne") }}
            </p>
          </article>
          <p class="image">
            <img
              src="../assets/images/movie-theatre-bg.jpg"
              alt="IMMERSIVE 3D INVIRONMENT"
              :style="{
                width:
                  fullWidth <= 1500
                    ? 3000 + 'px'
                    : fullWidth <= 1920
                    ? fullWidth * 2 + 'px'
                    : 3840 + 'px',
                left:
                  fullWidth <= 1500
                    ? -1500 + fullWidth / 2 + 'px'
                    : fullWidth >= 1920
                    ? -1920 + fullWidth * 0.5 + 'px'
                    : -fullWidth * 0.5 + 'px',
              }"
            />
          </p>
        </section>

        <section class="overview-product">
          <article class="content-wrapper">
            <h3 class="title">{{ $t("m.product.elegant") }}</h3>
            <h3 class="title">{{ $t("m.product.elegantOne") }}</h3>
            <p class="description">
              <span class="inline-block">
                {{ $t("m.product.eleOne") }}
              </span>
              <span class="inline-block">
                {{ $t("m.product.eleTwo") }}
              </span>
            </p>
          </article>
          <p class="image">
            <img
              src="../assets/images/product-en.jpg"
              data-2x=""
              alt="ELEGANT USER EXPERIENCE"
              :style="{
                left:
                  fullWidth <= 1820
                    ? fullWidth <= 1200
                      ? -310 + 0.26 * (1200 - fullWidth) + 'px'
                      : -0.5 * (1820 - fullWidth) + 'px'
                    : 0,
                width:
                  fullWidth <= 1200
                    ? 1820 - 1.52 * (1200 - fullWidth) + 'px'
                    : 1820 + 'px',
              }"
            />
          </p>
        </section>

        <section class="mode">
          <article class="content-wrapper">
            <div class="text-container">
              <h3 class="title">
                <span class="inline-block" v-html="$t('m.product.all')"></span>
                <span class="inline-block">
                  {{ $t("m.product.allOne") }}
                </span>
              </h3>
              <p class="description">
                {{ $t("m.product.allTwo") }}
              </p>
            </div>
            <p class="image">
              <img
                src="../assets/images/mode-en.png"
                data-2x=""
                alt="SUPPORT ALL STEORO MODE"
              />
            </p>
          </article>
        </section>

        <section class="engine">
          <article class="content-wrapper">
            <p class="image">
              <img
                src="../assets/images/engine.jpg"
                data-2x=""
                alt="RECOGNITION ENGINE"
              />
            </p>
            <div class="text-container">
              <h3 class="title">{{ $t("m.product.engine") }}</h3>
              <p class="description">
                {{ $t("m.product.engineOne") }}
              </p>
            </div>
          </article>
        </section>

        <section class="formats">
          <article class="content-wrapper">
            <h3 class="title">
              <span class="inline-block" v-html="$t('m.product.all')"></span>
              <span class="inline-block">{{ $t("m.product.format") }}</span>
            </h3>
            <p class="description">
              <span class="inline-block">{{ $t("m.product.formatOne") }} </span>
            </p>
            <ul class="formats-list">
              <li class="formats-item">
                <h6 class="formats-icon">
                  <img
                    src="../assets/images/format-1.png"
                    data-2x=""
                    alt="mp4, mkv, avi, mov, wav, rmvb, flv, 3gp, webm"
                  />
                </h6>
                <p class="formats-text">
                  mp4, mkv, avi, mov, wmv, rmvb, flv, 3gp, webm, vob
                </p>
              </li>
              <li class="formats-item">
                <h6 class="formats-icon">
                  <img
                    src="../assets/images/format-2.png"
                    data-2x=""
                    alt="2D, 3D-Side by Side, 3D-TopBottom, 180°, 360°"
                  />
                </h6>
                <p class="formats-text">
                  {{ $t("m.product.side") }}
                </p>
              </li>
              <li class="formats-item">
                <h6 class="formats-icon">
                  <img
                    src="../assets/images/format-3.png"
                    data-2x=""
                    alt="ass, srt, sub, <br /> ssa, ttml, vtt"
                  />
                </h6>
                <p class="formats-text">{{ $t("m.product.sub") }}</p>
              </li>
            </ul>
          </article>
        </section>

        <section class="support-4k">
          <article class="content-wrapper">
            <p class="image">
              <img src="../assets/images/8k.jpg" data-2x="" alt="8k support" />
            </p>
            <h3 class="title">
              <em v-html="$t('m.product.eightk')"></em
              ><span class="support">{{ $t("m.product.sup") }}</span>
            </h3>
            <p class="description">
              {{ $t("m.product.supOne") }}
            </p>
          </article>
        </section>

        <section class="local-media">
          <article class="content-wrapper">
            <p class="image">
              <img
                src="../assets/images/DLAN.png"
                data-2x=""
                alt="Enjoy Your Videos On Local Media Server"
              />
            </p>
            <h3 class="title">{{ $t("m.product.enjoy") }}</h3>
            <p class="description">
              <span
                class="inline-block"
                v-html="$t('m.product.enjoyOne')"
              ></span>
              <span class="inline-block"> {{ $t("m.product.enjoyTwo") }}</span>
            </p>
          </article>
        </section>

        <section class="product-features" :class="{ zh: $t('m.lang') == 'zh' }">
          <article class="content-wrapper">
            <h3 class="title">{{ $t("m.product.feat") }}</h3>
            <div class="text-container">
              <ul class="description">
                <li class="feature-item">
                  {{ $t("m.product.featOne") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featTwo") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featThree") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featFour") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featFive") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featSix") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featSeven") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featEight") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featNine") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featTen") }}
                </li>
                <li class="feature-item">
                  {{ $t("m.product.featEleven") }}
                </li>
              </ul>
            </div>
          </article>
        </section>

        <section class="download-footer">
          <section class="content-wrapper">
            <p class="logo">
              <img
                src="../assets/images/download-footer.png"
                data-2x=""
                alt="download skybox"
              />
            </p>
            <p class="description">
              <router-link to="/get-zh" class="btn-download">
                <span class="icon-round-arrow-down"
                  ><svg
                    id="图层_1"
                    data-name="图层 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16.14 13.44"
                  >
                    <title>buy now</title>
                    <path
                      class="path-fill"
                      d="M14.75,8.75H6.36L3.49.38A.56.56,0,0,0,3,0H.56A.67.67,0,0,0,0,.67a.64.64,0,0,0,.56.65h2L5.43,9.67a.56.56,0,0,0,.53.38h8.78a.72.72,0,0,0,.67-.63A.76.76,0,0,0,14.75,8.75Zm.89-7.13-9.87-.3a.35.35,0,0,0-.37.51L7,7a.76.76,0,0,0,.76.41H15a.65.65,0,0,0,.63-.56l.52-4.62A.51.51,0,0,0,15.64,1.62Zm-2.23,9.12a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,13.41,10.74Zm-5.34,0a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,8.07,10.74Z"
                    ></path></svg></span
                >{{ $t("m.product.getapp") }}
              </router-link>
            </p>
          </section>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import global_ from "../components/Global.vue";
import i18n from "../lang";
export default {
  data() {
    return {
      lang: global_.languageZh,
      fullWidth: document.documentElement.clientWidth,
      iconNum: "",
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);

    i18n.global.locale = "zh";
    zE("webWidget", "show"); //进到页面就启动组件
    zE("webWidget", "setLocale", "zh-CN"); //设置语言

    window.zESettings = {
      webWidget: {
        color: { theme: "#fed65d" },
        offset: { horizontal: "25px", vertical: "25px" },
        contactForm: {
          attachments: true,
          ticketForms: [
            {
              id: 1500003115541,
              title: false,
              subject: false,
              fields: [
                {
                  id: "description",
                  labels: {
                    "*": "测试",
                  },
                  hint: {
                    "zh-CN":
                      "如在使用中遇到任何问题，请描述问题本身和如何遇到问题的。如想要 SKYBOX 支持新的功能，请描述你的需求和使用场景。",
                  },
                  prefill: { "*": " " },
                },
              ],
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.getMatch();
    if (this.fullWidth > 767) {
      document.querySelector(".productLi").style.color = "#fff";
    }
  },
  beforeUnmount: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getMatch() {
      switch (Math.floor(Math.random() * 4)) {
        case 0:
          this.iconNum = require("../assets/images/icon-headset-vive.png");
          break;
        case 1:
          this.iconNum = require("../assets/images/icon-headset-daydream.png");
          break;
        case 2:
          this.iconNum = require("../assets/images/icon-headset-quest.png");
          break;
        case 3:
          this.iconNum = require("../assets/images/icon-headset-gear.png");
          break;
      }
    },
    //监听窗口大小
    handleResize(event) {
      this.fullWidth = document.documentElement.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/product.scss";
</style>